
import { Card, CardContent, CardFooter, CardHeader } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

export const WritingAreaSkeleton = () => {
  return (
    <Card className="bg-stone-100 dark:bg-stone-900 border border-stone-200 dark:border-stone-700 rounded-xl">
      <CardHeader className="px-4 py-0">
        <div className="flex justify-between items-center">
          <div className="flex gap-4">
            <Skeleton className="h-6 w-24" />
            <Skeleton className="h-6 w-24" />
          </div>
          <Skeleton className="h-6 w-24" />
        </div>
      </CardHeader>
      <CardContent className="px-0">
        <div className="bg-white dark:bg-stone-800 min-h-[400px] rounded-xl px-8 py-6 border-b border-stone-200 dark:border-stone-700">
          <div className="space-y-4">
            {[1, 2, 3, 4, 5].map((i) => (
              <Skeleton key={i} className="h-4 w-full" />
            ))}
          </div>
        </div>
      </CardContent>
      <CardFooter className="px-8">
        <div className="ml-auto flex gap-4">
          <Skeleton className="h-10 w-24" />
          <Skeleton className="h-10 w-24" />
        </div>
      </CardFooter>
    </Card>
  );
};
